import React from 'react';
import { Flex, Text, UnstyledButton } from '@mantine/core';
import { TbArrowLeft } from 'react-icons/tb';
import { ACTION_TYPES } from './consts';

interface DrawerTitleProps {
  action: {
    type: 'JURISDICTIONS' | 'SELECT_FUND' | 'ADDITIONAL_INFORMATION';
  };
  selectedJurisdiction: {
    country_name: string;
  };
  onBack: () => void;
}

export const DrawerTitle: React.FC<DrawerTitleProps> = ({
  action,
  selectedJurisdiction,
  onBack
}) => {
  if (action.type === ACTION_TYPES.SELECT_FUND) {
    return (
      <Flex id="export-drawer-title-select-fund" align="center" gap="8px">
        <UnstyledButton id="export-drawer-title-select-fund-back-button" onClick={onBack}>
          <TbArrowLeft color="#868E96" size={16} />
        </UnstyledButton>
        <Flex id="export-drawer-title-select-fund-content" gap="4px">
          <Text id="export-drawer-title-select-fund-root-label" fz="16px" lh="22px">
            Export Settings
          </Text>
          <Text id="export-drawer-title-select-fund-separator-left" fz="16px" lh="22px">
            /
          </Text>
          <Text id="export-drawer-title-select-fund-country" fz="16px" c="blue" lh="22px">
            {selectedJurisdiction.country_name}
          </Text>
          <Text id="export-drawer-title-select-fund-separator-right" fz="16px" lh="22px">
            /
          </Text>
          <Text id="export-drawer-title-select-fund-label" fz="16px" lh="22px">
            Select Funds
          </Text>
        </Flex>
      </Flex>
    );
  }

  if (action.type === ACTION_TYPES.ADDITIONAL_INFORMATION) {
    return (
      <Flex id="export-drawer-title-additional-information" align="center" gap="8px">
        <UnstyledButton
          id="export-drawer-title-additional-information-back-button"
          onClick={onBack}
        >
          <TbArrowLeft color="#868E96" size={16} />
        </UnstyledButton>
        <Flex id="export-drawer-title-additional-information-content" gap="4px">
          <Text
            id="export-drawer-title-additional-information-root-label"
            fz="16px"
            c="blue"
            lh="22px"
          >
            Export Settings
          </Text>
          <Text id="export-drawer-title-additional-information-separator" fz="16px" lh="22px">
            /
          </Text>
          <Text id="export-drawer-title-additional-information-label" fz="16px" lh="22px">
            Additional Information
          </Text>
        </Flex>
      </Flex>
    );
  }

  return 'Export Settings';
};
